import { useMutation, useQueryClient } from 'react-query';
import { AnchorAPI } from 'modules/AnchorAPI';
import { FETCH_EPISODE_OVERVIEW } from './useFetchEpisodeOverview';

function useDeleteMediaFromEpisode() {
  const queryClient = useQueryClient();
  const { mutate, status } = useMutation(
    ({ webEpisodeId }: { webEpisodeId: string }) => {
      if (!webEpisodeId) {
        return Promise.reject(
          new Error('webStationId is required to delete media from episode')
        );
      }

      return AnchorAPI.deleteMediaFromEpisode({
        webEpisodeId,
      });
    },
    {
      onSuccess: (_date, variables) => {
        const { webEpisodeId } = variables;
        return queryClient.invalidateQueries([
          FETCH_EPISODE_OVERVIEW,
          webEpisodeId,
        ]);
      },
    }
  );

  return {
    deleteMediaFromEpisode: mutate,
    deleteMediaFromEpisodeStatus: status,
  };
}

export { useDeleteMediaFromEpisode };
